import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "43",
  height: "43",
  viewBox: "0 0 51.498 51.498"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "data-name": "Path 8016",
  d: "M27.62 2.18v3.436a18.679 18.679 0 1 1-6.794 0V2.18a22.068 22.068 0 1 0 6.794 0",
  transform: "translate(-2.155 -2.18)",
  style: {"fill":"#fff"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };